import { useState,useEffect } from 'react'
import ReactApexCharts from 'react-apexcharts'
import { getCSSVariableValue } from '../../../../../../_metronic/assets/ts/_utils'
import { ApexOptions } from "apexcharts";



function dosDecimales(n:any) {
    let t=n.toString();
    let regex=/(\d*.\d{0,2})/;
    return t.match(regex)[0];
  }

export default function Pruebachart(props:{total:number, exedido:number, name:string,disponible: number, className: string, chartColor: string, chartHeight: number}) {
    const baseColor = getCSSVariableValue('--bs-' + props.chartColor)
    const lightColor = getCSSVariableValue('--bs-' + props.chartColor + '-light')
    const labelColor = getCSSVariableValue('--bs-gray-700')

const options: ApexOptions = {
        chart: {
            fontFamily: 'inherit',
            height: props.chartHeight,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              hollow: {
                margin: 0,
                size: '65%',
              },
              dataLabels: {
                name: {
                  show: true,
                  fontWeight: '100',
                },
                value: {
                  color: labelColor,
                  fontSize: '20px',
                  fontWeight: '700',
                  offsetY: 12,
                  show: true,
                  formatter: function (val:any) {
                    return val + '%'
                  },
                },
              },
              track: {
                background: lightColor,
                strokeWidth: '100%',
              },
            },
          },
          colors: [baseColor],
          stroke: {
            lineCap: 'butt',
          },
          labels: ['Available'],
    }

   
 const [prueba, setprueba] = useState({
          
    series: [Number(dosDecimales((props.disponible/props.total)*100))],
            
})

useEffect( () => {
    setprueba({ series: [Number(dosDecimales((props.disponible/props.total)*100))]})
    
 }, [props.disponible , props.total])





    return(
        <div className="card 0  border border-gray-300 card-xxl-stretch mb-5 mb-xl-10 justify-content-between">
        <div className="d-flex flex-row flex-column-fluid">
          <div className='row'>
            <div className="col-md-6">
              <div className='flex-grow-1'>
                <ReactApexCharts options={options} series={prueba.series} type="radialBar" height={props.chartHeight} />
              </div>
            </div>
  
            <div className="col-md-6">
              <div className="card-body d-flex flex-column justify-content-between mt-9 bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0">
                <p className='text-center f-titulo  text-marino fs-1'>{props.name}</p>
                { props.disponible !==0 ?
                <p className='text-center f-bold text-marino fs-2 pb-0 '>
                 Total / Available
                </p>:
                  <p className='text-center f-bold text-marino fs-2 pb-1 '>
                     Exceeded: 
                   </p>
  
                  }
                { props.disponible !==0 ?
                  <p className='text-center fs-3 pb-0 '>
                      <span className='badge badge-light-success f-parrafo fs-3'>{props.total} GB  /  {props.disponible} GB  </span>
                      <br />
                  </p> : 
                    <p className='text-center fs-8 pb-5 '>
                        <span className='badge badge-light-danger f-parrafo fs-2'>{props.exedido} GB</span>
                    <br />
                </p>
                }

              </div>
            </div>
          </div>
        </div>
      </div>
    )
}